import React from 'react';

/** "Here's what we know" card (Rocket Money): one plain sentence first, then the facts behind it as rows. */
// Empty rows are not drawn and the band only introduces rows that exist; the edit action sits by the title (UX plan D4c).
export function FactCard({title,text,band,rows,action}){
 const visible=rows.filter(row=>row.value);
 return <section className="onboarding-facts">
  <div className="onboarding-facts-lead"><div className="onboarding-facts-title"><strong>{title}</strong>{action&&<span className="onboarding-facts-action">{action}</span>}</div>{text&&<p>{text}</p>}</div>
  {visible.length>0&&<>{band&&<div className="onboarding-facts-band">{band}</div>}
  <dl className="onboarding-facts-rows">{visible.map(row=><div key={row.label}><dt>{row.label}</dt><dd>{row.value}</dd></div>)}</dl></>}
 </section>;
}

/** General summary: one card, a quiet band per section (same band as FactCard), facts as rows. */
export function SummaryCard({sections}){
 return <section className="onboarding-facts onboarding-summary">{sections.map(section=>{const rows=section.rows.filter(row=>row.value);return rows.length?<React.Fragment key={section.title}>
  <h2 className="onboarding-facts-band">{section.title}</h2>
  <dl className="onboarding-facts-rows">{rows.map(row=><div key={row.label}><dt>{row.label}</dt><dd>{row.value}</dd></div>)}</dl>
 </React.Fragment>:null;})}</section>;
}
